import { Notify } from 'application/Shared/Helpers';
import Core from 'application/Shared/Helpers/Functions';
import Requests from 'application/Shared/Requests/Handler';
import axios from 'axios';
import i18n from 'i18n';

export default class DataAPI {
    constructor(config) {
        this.config = {
            parameters: {},
            route: '',
            ...config
        };
        this.hash = undefined;
        this.cachedData = [];

        /*  Requests  */
        this.requests = new Requests();
    }

    getResults = async (signal) => {
        const params = this.getParams();

        const body = {
            cancelToken: this.requests.token(),
            params
        };
        if (signal) {
            body.signal = signal;
        }

        try {
            const response = await axios.get(this.config.route, body);

            if (Core.isset(response, 'data', 'data')) {
                const { data } = response.data;
                this.cachedData = data;
                return data;
            }
            return null;
        } catch (e) {
            if (axios.isCancel(e)) {
                return { status: 'canceled' };
            }
            Notify.e(i18n.t('DataApi.error.notification'));
            return { status: 'error' };
        }
    };

    setData = (data) => {
        this.cachedData = data;
    };

    cancel = () => {
        this.requests.cancel();
    };

    getCache = () => this.cachedData;

    getConfig = () => ({
        ...this.config,
        parameters: { ...this.config.parameters }
    });

    getParams = () => this.config.parameters;

    addParameter = (param, value) => {
        let constructedValue = value;
        if (
            (Array.isArray(value) || Core.isArrayString(value)) &&
            value.length > 1
        ) {
            constructedValue = Core.toSortedArrayString(value);
        }
        if (Array.isArray(value) && value.length === 1) {
            [constructedValue] = value;
        }
        this.config.parameters[param] = constructedValue;
        this.generateHash();
    };

    addParameters = (params) => {
        Object.entries(params).forEach(([key, value]) => {
            this.addParameter(key, value);
        });
        this.generateHash();
    };

    resetParams = () => {
        this.config.parameters = {};
    };

    deleteParameter = (param) => {
        if (this.config.parameters[param]) {
            delete this.config.parameters[param];
            this.generateHash();
        }
    };

    generateHash = () => {
        this.hash = Math.random();
    };

    getHash = () => this.hash;
}
